import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectActivePrices,
  selectInActivePrices,
  addNewPrice,
  updatePrice,
  removePrice,
} from 'components/QuestionnaireRequest/Property/store/slice'
import Pricing from './Pricing'

const PropertySettingTabPricing = (props) => {
  const dispatch = useDispatch()
  const activePrices = useSelector(selectActivePrices)
  const inActivePrices = useSelector(selectInActivePrices)
  const onAddNewPrice = useCallback((newItem) => dispatch(addNewPrice(newItem)), [dispatch])
  const onUpdatePrice = useCallback(
    ({ oldKey, updatedPrice }) => dispatch(updatePrice({ oldKey, updatedPrice })),
    [dispatch]
  )
  const onRemovePrice = useCallback((priceId) => dispatch(removePrice(priceId)), [dispatch])

  return (
    <div style={{ width: 900 }}>
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <div className="questionnaire-admin-general-table-container">
          <div className="dome-d-flex dome-flex-column dome-gap12">
            <div className="dome-d-flex dome-justify-between">
              <div>
                <span className="dome-p1 dome-color-darkest-grey">active prices</span>
              </div>
              <div>
                <button type="button" className="dome-btn dome-btn-base dome-btn-green-stroke">
                  <div className="dome-d-flex dome-align-center dome-gap6">
                    <span>
                      <i className="fa-light fa-message-question dome-color-dark-green"></i>
                    </span>
                    <span className="dome-p2 dome-color-dark-green">need help?</span>
                  </div>
                </button>
              </div>
            </div>
            <Pricing
              buildingId={props.building.id}
              prices={activePrices}
              onAddNewPrice={onAddNewPrice}
              onUpdatePrice={onUpdatePrice}
              onRemovePrice={onRemovePrice}
            />
          </div>
        </div>
        {inActivePrices.length > 0 && (
          <div className="questionnaire-admin-general-table-container">
            <div className="dome-d-flex dome-flex-column dome-gap12">
              <span className="dome-p1 dome-color-med-grey">inactive prices</span>
              <Pricing
                disabled
                buildingId={props.building.id}
                prices={inActivePrices}
                onAddNewPrice={onAddNewPrice} // should never be called. TODO: refactor
                onUpdatePrice={onUpdatePrice}
                onRemovePrice={onRemovePrice} // should never be called. TODO: refactor
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default PropertySettingTabPricing
